// extracted by mini-css-extract-plugin
export default {"contentBox":"myCheck_contentBox__UOyvG","title":"myCheck_title__uOuOL","description":"myCheck_description__1cbeN","inputBox":"myCheck_inputBox__Ps6Iy"};